module.exports = __webpack_public_path__ + "static/media/m_beard_stiletto_round__oval_vector.8bff7fdc.svg";